import script from "./AuthFormRememberForget.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthFormRememberForget.vue?vue&type=script&setup=true&lang=ts"

import "./AuthFormRememberForget.vue?vue&type=style&index=0&id=613997ec&scoped=true&lang=scss"

import exportComponent from "/var/www/fgc-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-613997ec"]])

export default __exports__